import { Card, CardContent, Button } from "@mui/material";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import ProductDetail from "./ProductDetail";
import productBGeffect from "../../assets/images/productBGeffect.webp";
import ImageWithLoader from "../ImageWithLoading";

const ProductCard = ({ product }) => {
  const [expanded, setExpanded] = useState(false);
  const [detail, openDetail] = useState(false);
  const [ref, inView] = useInView();
  let imageUrl;
  try {
    imageUrl = require(`../../assets/images/products${
      product && product.image ? product.image.split(",")[0] : "/DSC_1956.webp"
    }`);
  } catch (error) {
    imageUrl = require("../../assets/images/products/default.webp"); // default image
  }

  return (
    <AnimatePresence>
      <motion.div
        ref={ref}
        initial={{ opacity: 0 }}
        animate={{ opacity: inView ? 1 : 0 }}
        transition={{ duration: 1 }}
      >
        <Card
          sx={{
            borderRadius: 10,
            minHeight: { md: 400 },
            width: { sm: "80%", md: 400 },
            alignContent: "center",
            margin: 1,
            backgroundImage: `url(${productBGeffect})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            overflow: "auto",
          }}
        >
          <CardContent>
            <div className="flex flex-col overflow-y-hidden">
              <Card
                sx={{
                  borderRadius: 8,
                  alignContent: "center",
                }}
              >
                <CardContent
                  sx={{
                    padding: 0,
                    "&:last-child": {
                      paddingBottom: 0,
                    },
                  }}
                >
                  <ImageWithLoader src={imageUrl} alt={"product image"} />
                </CardContent>
              </Card>
              <div className="font-HNlight text-2xl md:text-3xl p-2 capitalize">
                {product.Name}
              </div>

              <AnimatePresence>
                <motion.div
                  initial={{ height: 0 }}
                  animate={{
                    height: expanded ? "auto" : 0,
                  }}
                  exit={{ height: 0 }}
                  className="overflow-hidden"
                >
                  <p className=" text-sm md:text-base px-2 font-HNlight">
                    {product.Description}
                  </p>
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: 10,
                      marginY: 1,
                      width: "100%",
                    }}
                    onClick={() => {
                      setExpanded(false);
                    }}
                  >
                    <Link to="/contactus">Place an Order</Link>
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: 10,
                      marginY: 1,
                      width: "100%",
                    }}
                    onClick={() => {
                      openDetail(true);
                      setExpanded(false);
                    }}
                  >
                    View More
                  </Button>
                </motion.div>
                <ProductDetail
                  key={product.Name}
                  product={product}
                  open={detail}
                  onClose={() => openDetail(false)}
                />
                ;
              </AnimatePresence>

              <Button
                variant={expanded ? "text" : "contained"}
                sx={{
                  borderRadius: 10,
                }}
                onClick={() => {
                  setExpanded(!expanded);
                }}
              >
                {expanded ? "View less" : "View details"}
              </Button>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </AnimatePresence>
  );
};

export default ProductCard;
